import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 px-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center">
          {/* 404 Illustration */}
          <div className="mx-auto mb-6 h-24 w-24 text-muted-foreground">
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              className="w-full h-full"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.462-.659-6.294-1.813M12 3c7.732 0 14 6.268 14 14 0 .886-.082 1.752-.238 2.592m0 0A14.022 14.022 0 0112 21c-7.732 0-14-6.268-14-14 0-.886.082-1.752.238-2.592m0 0A14.022 14.022 0 0112 3"
              />
            </svg>
          </div>

          <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
          
          <h2 className="text-2xl font-semibold mb-2">Page not found</h2>
          
          <p className="text-muted-foreground mb-8">
            Sorry, we couldn't find the page you're looking for. 
            It might have been moved, deleted, or the URL might be incorrect.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button onClick={() => window.history.back()} variant="outline" className="flex-1">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Button>
            <Link to="/" className="flex-1">
              <Button className="w-full">
                <Home className="mr-2 h-4 w-4" />
                Home
              </Button>
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t">
            <p className="text-sm text-muted-foreground">
              Need help?{' '}
              <a 
                href="mailto:support@localhost" 
                className="text-primary hover:underline"
              >
                Contact support
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}